module.exports = __webpack_public_path__ + "99efdf10d6b057561d73bfec3e6a37c9.svg";